import { useEffect, useState, useSyncExternalStore } from 'react'
import { embeddingSnapshot, subscribeEmbedding } from '../lib/app-embedding'

function ProxyRueckwegLeiste() {
  const [visible, setVisible] = useState(false)
  const embedded = useSyncExternalStore(subscribeEmbedding, embeddingSnapshot, () => false)

  useEffect(() => {
    const controller = new AbortController()
    const timeout = setTimeout(() => controller.abort(), 5000)
    void fetch(new URL('__rueckweg', document.baseURI).toString(), {
      credentials: 'include',
      cache: 'no-store',
      redirect: 'error',
      signal: controller.signal,
    })
      .then((response) => {
        if (!controller.signal.aborted && response.status === 204) setVisible(true)
      })
      .catch(() => {
        // Missing, expired or unreachable proof always leaves the bar hidden.
      })
      .finally(() => clearTimeout(timeout))
    return () => {
      controller.abort()
      clearTimeout(timeout)
    }
  }, [])

  if (!visible || embedded) return null
  return (
    <div
      data-rueckweg
      className="h-[28px] shrink-0 w-full bg-bg-base border-b border-border-subtle"
    >
      <a
        href={new URL('../', document.baseURI).toString()}
        rel="noreferrer"
        referrerPolicy="no-referrer"
        className="flex h-full w-fit items-center px-3 text-xs text-accent hover:text-accent-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent"
      >
        ← Darkserver
      </a>
    </div>
  )
}

// Compile the entire probe and link out of the public build.
export const RueckwegLeiste = import.meta.env.BASE_URL === '/' ? () => null : ProxyRueckwegLeiste
